import { selectFeatureFlags } from 'core/userContext';
import { selectEnabledPreviews } from 'modules/app/selectors';
import { useSelector } from 'react-redux';
import { ModalContextProvider } from 'utils/contexts/modal';
import { PAGE_TITLE } from '../constants';
import { DataQueryContextProvider, FiltersContextProvider } from '../contexts';
import { BillingQueryContextProvider } from '../contexts/BillingQueryContextProvider';
import { DATA_WAREHOUSE_PREVIEW_KEY } from '../featureFlags';
import { DataWarehouseModals } from './DataWarehouseModals';
import { Container, FullWidthBody } from './DataWarehousePage.styled';
import { PageHeader } from './PageHeader';
import { SourcesList } from './SourcesList';

export const DATA_WAREHOUSE_PAGE_TEXT = {
  pageTitle: PAGE_TITLE,
};

export const DataWarehouse = () => (
  <FullWidthBody>
    <Container>
      <PageHeader />
      <SourcesList />
    </Container>
  </FullWidthBody>
);

export const DataWarehousePage = () => {
  const { HightouchIntegration } = useSelector(selectFeatureFlags);
  const previews = useSelector(selectEnabledPreviews);

  const shouldShowPage = previews.includes(DATA_WAREHOUSE_PREVIEW_KEY) || !!HightouchIntegration;

  return (
    <>
      {shouldShowPage && (
        <ModalContextProvider>
          <DataQueryContextProvider>
            <BillingQueryContextProvider>
              <FiltersContextProvider>
                <DataWarehouse />
                <DataWarehouseModals />
              </FiltersContextProvider>
            </BillingQueryContextProvider>
          </DataQueryContextProvider>
        </ModalContextProvider>
      )}
    </>
  );
};
